import React, { useState, createContext } from 'react'
import themeConfig from '../../config/themeConfig'
import { useObjectCookie } from '../../hooks/useObjectCookie'

export const UserContext = createContext(null)

export const UserProvider = (props) => {

    const initialUser = {
        isLogin: false
    }

    // Cookies
    const [userCookie, updateUserCookie] = useObjectCookie(
        themeConfig.userCookieName,
        initialUser
    )

    // State
    const [_userState, _updateUserState] = useState(
        JSON.stringify(userCookie) !== '{}' ? userCookie : initialUser
    );

    const updateUser = (user) => {
        _updateUserState(prev => {
            const newUser = { ...prev, ...user }
            updateUserCookie(newUser);
            return newUser;
        })
    }

    const logout = () => {
        _updateUserState(prev => {
            updateUserCookie(initialUser);
            return initialUser;
        })
    }

    return (
        <UserContext.Provider
            value={{
                user: _userState,
                updateUser,
                logout                
            }}
        >
            {props.children}
        </UserContext.Provider>
    )

}